import { render, staticRenderFns } from "./ShippingRequestPop.vue?vue&type=template&id=2138acf4"
import script from "./ShippingRequestPop.vue?vue&type=script&lang=js"
export * from "./ShippingRequestPop.vue?vue&type=script&lang=js"
import style0 from "./ShippingRequestPop.vue?vue&type=style&index=0&id=2138acf4&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2138acf4')) {
      api.createRecord('2138acf4', component.options)
    } else {
      api.reload('2138acf4', component.options)
    }
    module.hot.accept("./ShippingRequestPop.vue?vue&type=template&id=2138acf4", function () {
      api.rerender('2138acf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/pdf/popup/ShippingRequestPop.vue"
export default component.exports